// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store';
import './assets/styles.scss';
import * as VueGoogleMaps from 'vue2-google-maps'

// Bulma CSS Framework
// Not necessary if using SASS
//import './../node_modules/bulma/css/bulma.css';

//import i18n from './i18n'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHammer, faMapMarkerAlt, faPhoneAlt, faMobileAlt, faStar, faBars, faTimesCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faHammer, faMapMarkerAlt, faPhoneAlt, faMobileAlt, faStar, faBars, faTimesCircle, faArrowLeft),
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;
//console.log(process.env);
//console.log(process.env.GOOGLE_API_KEY);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDL29jyuLVWtwgfxEXENqxEW5rGnhlg9YM',
    libraries: 'places'
  },
  installComponents: true
})

// Custom directive that triggers an event if you click outside of the element that has it (perfect for popups!)
Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

/* eslint-disable no-new */
/*new Vue({
  el: '#app',
  router,
  store: store,
  components: { App },
  template: '<App/>'
})*/

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')

